import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface PermissionChange {
  actionId: number;
  nuevoEstado: number;
}



export const ChangePermissionsBatch = async (
  IDRol: number,
  changes: PermissionChange[]
) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/change-permissions-roles-batch`;

    const token = localStorage.getItem('token');
    if (!token) throw new Error('Token no disponible');

    const response = await axios.post(
      endpoint,
      { IDRol, cambios: changes },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    return response.data;
  } catch (error) {
    console.error('Error en ChangePermissionsBatch:', error);
    throw error;
  }
};
